import React from 'react';
import './css/Main.css';

import { Link } from 'react-router-dom';

function whatsappSVG() {
  return(
    <svg xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 32 32"
      fill="white">
        <path d="M16.04 3C8.84 3 3 8.84 3 16.04c0 2.3.6 4.53 1.74 6.49L3 29l6.68-1.71a13.01 13.01 0 0 0 6.36 1.63c7.2 0 13.04-5.84 13.04-13.04S23.24 3 16.04 3zm0 23.7c-2.01 0-3.98-.54-5.71-1.56l-.41-.24-3.97 1.01 1.06-3.87-.27-.4a10.6 10.6 0 0 1-1.63-5.6c0-5.91 4.81-10.72 10.72-10.72s10.72 4.81 10.72 10.72-4.81 10.66-10.72 10.66zm5.87-8.05c-.32-.16-1.9-.94-2.19-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1.01 1.25-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.88-1.76-2.2-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.63-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.63s1.14 3.04 1.3 3.25c.16.21 2.25 3.44 5.45 4.82.76.33 1.35.53 1.81.68.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.17-1.53.27-.74.27-1.37.19-1.53-.08-.16-.29-.24-.61-.4z"/>
    </svg>
  )
}
export default function MainProcess() {
  return (
    <>
      <section id="process">
        <div className="card">
          <h2 className="section-title how-it-works">HOW IT WORKS</h2>
          <div className="whatsapp-section">
            <Link to="https://wa.me/601125829096" className="btn whatsapp-box">
              {whatsappSVG()}
              Contact Us
            </Link>
          </div>
          <div className="steps">
            <div className="step">
              <div className="number">1</div>
              Submit Enquiry
            </div>
            <div className="step">
              <div className="number">2</div>
              Vehicle Inspection
            </div>
            <div className="step">
              <div className="number">3</div>
              List On Platform
            </div>
            <div className="step">
              <div className="number">4</div>
              Match With Buyer
            </div>
            <div className="step">
              <div className="number">5</div>
              Ownership Transfer
            </div>
          </div>
        </div>
        <div className="card-mobile">
          <h2 className="section-title how-it-works">HOW IT WORKS</h2>
          <div className="step-mobile"><div className="num-mobile">1</div>Submit Enquiry</div>
          <div className="step-mobile"><div className="num-mobile">2</div>Professional Inspection</div>
          <div className="step-mobile"><div className="num-mobile">3</div>Vehicle Listed</div>
          <div className="step-mobile"><div className="num-mobile">4</div>Matched With Buyer</div>
          <div className="step-mobile"><div className="num-mobile">5</div>Ownership Transfer</div>
          <div className="whatsapp-section">
            <Link to="https://wa.me/601125829096" className="btn whatsapp-box">
              {whatsappSVG()}
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}